import { Image } from 'react-native';

export const Images = {
  ic_business_team: Image.resolveAssetSource(
    require('../../../assets/Icons/icBusinessTeamDark.png'),
  ),
  ic_admin: Image.resolveAssetSource(require('../../../assets/Icons/icAdminRed.png')),
};
